module.exports = __webpack_public_path__ + "img/lunbo53.2d978f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo53.png
// module id = zaC9
// module chunks = 0